<template>
  <!-- Code copied and modifed from legacy ConfirmModal.vue -->
  <div>
    <!-- Modal for quiz no correct answer -->
    <aha-modal
      v-if="type === 'quiz-no-correct-answer'"
      :title="data.title"
      @hide="$emit('hide')"
    >
      <div>
        <p class="pb-3">
          {{ data.description }}
        </p>
        <ul class="pl-4 mb-3 list-disc">
          <li
            v-for="(slide, slideIndex) in quizNoCorrectAnswer"
            :key="slideIndex"
            class="text-left reminder-content-item"
          >
            Slide {{ slide.index }}: {{ slide.title }}
          </li>
        </ul>
        <div
          class="form-check form-check-inline"
        >
          <aha-checkbox v-model="$store.state.presentation.notRemindCorrectAnswer">
            Do not remind me again for this presentation
          </aha-checkbox>
        </div>
      </div>
      <template #action>
        <aha-link @click="$emit('hide')">
          <span class="font-bold">Cancel</span>
        </aha-link>

        <aha-button
          has-margin-left
          @click="$emit('present')"
        >
          Present anyway
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ConfirmModal',
  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      quizNoCorrectAnswer: (state) => state.presentation.quizNoCorrectAnswer,
    }),
  },
}
</script>

<style lang="scss" scoped>
.folder-content-list {
  max-height: 90px;
}
</style>
